<template>
  <div>
    <div id="page">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <div class="myPopup noOpen">
      <div class="myPopup_box">
        <div class="myPopup_main">
          <img src="@/assets/icon_tip.png" alt="" srcset="">
          <p>暂未开放 敬请期待!</p>
        </div>
        <div class="myPopup_close" @click="close"></div>
      </div>
    </div>
    <div class="myPopup ticketOpen">
      <div class="myPopup_box">
        <div class="myPopup_main"></div>
        <div class="myPopup_close" @click="close"></div>
      </div>
    </div>
  </div>
  <!-- <div class="mouse_pic"></div> -->
</template>

<script>
import Vue from 'vue'
export default {
  methods: {
    close() {
      $('.myPopup').removeClass('myPopup_box_show')
    },
    // 鼠标跟随
    setMouse() {
      var mouseFollow = $(".mouse_pic");
      document.addEventListener("mousemove", getMouse);
      var beepos = {
        x: 0,
        y: 0
      };
      var mouse = {
        x: 0,
        y: 0
      };
      setInterval(followMouse, 25);
      function getMouse(e) {
        mouse.x = e.clientX;
        mouse.y = e.clientY;
      }
      function followMouse() {
        var distX = mouse.x - beepos.x;
        var distY = mouse.y - beepos.y;

        beepos.x += distX / 5;
        beepos.y += distY / 2;
        mouseFollow.css('left', beepos.x + "px");
        mouseFollow.css('top', beepos.y + "px");
      }
    },
  },
  mounted() {
    // this.setMouse();
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: 'SourceRegular';
  src: url('@/assets/font/SourceHanSansCN-Regular.otf');
  font-style: normal;
}
@font-face {
  font-family: 'SourceBold';
  src: url('@/assets/font/SourceHanSansCN-Bold.otf');
  font-style: normal;
}
@font-face {
  font-family: 'HKGroteskBold';
  src: url('@/assets/font/HKGrotesk-Bold.otf');
  font-style: normal;
}
@font-face {
  font-family: 'HKGroteskSemiBold';
  src: url('@/assets/font/HKGrotesk-SemiBold.otf');
  font-style: normal;
}
a,
img {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
body,
html {
  /* font-family: Alibaba; */
  font-family: SourceRegular, '微软雅黑', 'Helvetica Neue', Helvetica, Arial,
    sans-serif;
  font-size: 28px;
  line-height: 1.42857143;
  color: #000;
  background: #fff;
  width: 100%;
  overflow-x: hidden;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/**
/*	a重置
/* ==========================================*/
a {
  color: inherit;
  text-decoration: none;
  /*下划线*/
  border: 0;
  /*去掉a点击时出现的蓝框*/
}

/*去掉点击a标签时出现的蓝色背景*/
a,
a:hover,
a:active,
a:visited,
a:link,
a:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  outline: none;
  background: none;
  text-decoration: none;
}
/* 防止出现两个滚动条 */
body {
  overflow: hidden;
}
html {
  overflow-y: auto;
}
/**
/*	ul重置
/* ==========================================*/
ul {
  list-style: none;
}

video::-webkit-media-controls-enclosure {
  display: none !important;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix {
  zoom: 1;
}

.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  height: 0;
  line-height: 0;
  clear: both;
}
img {
  max-width: 100%;
}

/* mouse_pic */
.mouse_pic {
  width: 16px;
  height: 16px;
  background-color: #fdd12e;
  border-radius: 50%;
  position: fixed;
  z-index: 1000;
  pointer-events: none;
  transform: translate(-50%, -50%);
  transition: height 200ms, width 200ms, border-color 200ms, border-width 200ms;
}
.mouse_pic_light {
  border: 6px solid #fdd12e;
  background-color: rgba(0, 0, 0, 0);
  width: 36px;
  height: 36px;
  opacity: 1;
}

/* word_hide */
.word_hide {
  overflow: hidden;
  white-space: nowrap;
}
.word_hide > span {
  width: 100%;
  display: inline-block;
  transition: transform 0s cubic-bezier(0.19, 1, 0.22, 1);
  transform: translate(0, 110%);
}
.word_show > span {
  transform: translate(0, 0);
  transition: transform 1s cubic-bezier(0.19, 1, 0.22, 1);
}
.word_hide .text_justify {
  width: 100%;
  text-align-last: justify;
}

/* 显示一行 */
.ellipsis-l1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ellipsis-l2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* 中文英文标题 */
.linear_word {
  font-size: 70px;
  background: #ffe5d3;
  background: -moz-linear-gradient(#ffe6d4, rgba(255, 255, 255, 0) 78%);
  background: -webkit-linear-gradient(#ffe6d4, rgba(255, 255, 255, 0) 78%);
  background: -o-linear-gradient(#ffe6d4, rgba(255, 255, 255, 0) 78%);
  background: -ms-linear-gradient(#ffe6d4, rgba(255, 255, 255, 0) 78%);
  background: linear-gradient(#ffe6d4, rgba(255, 255, 255, 0) 78%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: HKGroteskBold;
  user-select: none;
}
.linear_word2 {
  font-size: 70px;
  font-family: SourceBold;
  margin-top: -46px;
}

/* 漂浮物 */
.pao {
  position: absolute;
  pointer-events: none;
}

.noOpen {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  transition: opacity 0.6s;
  opacity: 0;
  pointer-events: none;
}
.myPopup_box_show {
  opacity: 1 !important;
  pointer-events: inherit !important;
}
.noOpen .myPopup_box {
  width: 626px;
  margin: 0 auto;
  position: relative;
  /* // background: #fff; */
}

.noOpen .myPopup_main {
  border-radius: 20px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 6px 20px 0px rgba(158, 189, 220, 0.5);
  width: 593px;
  height: 320px;
  position: relative;
  z-index: 1;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.noOpen .myPopup_main img {
  width: 70px;
}
.noOpen .myPopup_main p {
  font-size: 24px;
  margin-top: 20px;
}
.noOpen .myPopup_close {
  width: 80px;
  height: 80px;
  background: url('./assets/icon_close.png');
  background-size: 100% 100%;
  cursor: pointer;
  position: absolute;
  top: -40px;
  right: -10px;
  z-index: 2;
  cursor: pointer;
  transition: all 0.5s;
}
.noOpen .myPopup_close:hover {
  transform: rotate(180deg);
}

.ticketOpen {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  transition: opacity 0.6s;
  opacity: 0;
  pointer-events: none;
}

.ticketOpen .myPopup_box {
  width: 1030px;
  margin: 0 auto;
  position: relative;
}

.ticketOpen .myPopup_main {
  width: 1030px;
  height: 563px;
  background: url('./assets/ticket_code.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  z-index: 1;
}

.ticketOpenWaterPark .myPopup_main {
  background: url('./assets/ticket_codewaterPark.png') no-repeat !important;
}

.ticketOpen .myPopup_close {
  width: 80px;
  height: 80px;
  background: url('./assets/icon_close.png');
  background-size: 100% 100%;
  cursor: pointer;
  position: absolute;
  top: -25px;
  right: -18px;
  z-index: 2;
  cursor: pointer;
  transition: all 0.5s;
}
.ticketOpen .myPopup_close:hover {
  transform: rotate(180deg);
}

/* 后台文章 */
.my_topic{
  img{
    width: 100%;
  }
  p {
    text-indent: 2em;
    min-height: 1em;
    line-height: 1.6;
    color: #000;
  }
  table {
    width: 100%;
    min-width: unset !important;
    max-width: 100%;
    table-layout: fixed;
    word-break: break-all;
    overflow: hidden;
    box-sizing: border-box;
    border-collapse: separate;
    border-spacing: 0;
    background: #f8faff;
    border: 2px solid #000;
    border-collapse: collapse;
    th, td{
      border: 1px solid #000;
      border-collapse: collapse;
      box-sizing: border-box;
      padding: 16px 8px;
    }
    p{
      text-indent: 0 !important;
      line-height: 1.4;
    }
  }
}
</style>
